import { ActiveTournamentPlan, Plan } from '../domain/interfaces/plan';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  createFetchActiveTournamentPlanReducer,
  createFetchOrganizersReducer,
  createGivePlanReducer,
  createTopupBalanceReducer,
} from './redusers';

import { Organizer } from '../domain/interfaces/organizer';

export type OrganizersSliceState = {
  organizers: Organizer[];
  plans: {
    list: Plan[];
    byOwnerId: Record<number, ActiveTournamentPlan | null>;
  };
  filter?: string;
  sortByDate?: string;
  filterBySportType?: string;
  filterByNumber?: string;

  hasNextPage: boolean;
  currentPage: number;
  perPage: number;

  isLoaded: boolean;
  isLoading: boolean;

  isProcessing: boolean;
  isProcessed: boolean;
  processName?: string;
};

const initialState: OrganizersSliceState = {
  organizers: [],
  plans: {
    byOwnerId: {},
    list: [
      {
        id: 0,
        name: 'Бесплатный',
        price: 0,
      },
      {
        id: -1,
        name: 'Базовый',
        price: 1500,
      },
      {
        id: -2,
        name: 'Продвинутый',
        price: 2500,
      },
      {
        id: 2,
        name: 'Профессиональный',
        price: 10000,
      },
    ],
  },
  filter: '',
  sortByDate: undefined,
  filterBySportType: undefined,
  filterByNumber: undefined,

  hasNextPage: false,
  currentPage: 1,
  perPage: 20,

  isLoaded: false,
  isLoading: false,

  isProcessing: false,
  isProcessed: false,
};

const slice = createSlice({
  name: 'organizers',
  initialState,
  extraReducers: (builder) => {
    createFetchOrganizersReducer(builder);
    createFetchActiveTournamentPlanReducer(builder);
    createTopupBalanceReducer(builder);
    createGivePlanReducer(builder);
  },
  reducers: {
    setOrganizers: (state, action: PayloadAction<Organizer[]>) => {
      state.organizers = action.payload;
    },
    setFilter: (state, action: PayloadAction<string | undefined>) => {
      state.filter = action.payload;
    },
    setSortByDate: (state, action: PayloadAction<string | undefined>) => {
      state.sortByDate = action.payload;
    },
    setFilterBySportType: (state, action: PayloadAction<string | undefined>) => {
      state.filterBySportType = action.payload;
    },
    setFilterByNumber: (state, action: PayloadAction<string | undefined>) => {
      state.filterByNumber = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setPerPage: (state, action: PayloadAction<number>) => {
      state.perPage = action.payload;
    },
    resetPage: (state) => {
      state.currentPage = 1;
    },
  },
});

const organizersReducer = slice.reducer;
export const {
  setOrganizers,
  setFilter,
  setSortByDate,
  setFilterBySportType,
  setFilterByNumber,
  setCurrentPage,
  setPerPage,
  resetPage,
} = slice.actions;
export default organizersReducer;
